module.exports = __webpack_public_path__ + "static/goliath-2-859378854da38dfe1cb178872aa1c8a9.jpg";